import gql from 'graphql-tag'

export const deviceChangeDeviceAdmin = gql`
  mutation deviceChangeDeviceAdmin($deviceId: ID!, $email: EmailAddress!) {
    deviceChangeDeviceAdmin(input: { deviceId: $deviceId, email: $email }) {
      success
    }
  }
`
